import React, { useEffect } from "react";
import EliglibilityResponseContainer from "./EliglibilityResponseContainer";
import { Tab } from "react-bootstrap";
import EligibilityReposnePersonalDetails from "./EligibilityReposnePersonalDetails";
import BenefitsTable from "./BenefitsTable";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GetSingleEligibilityData } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";

const EliglibilityResposne = () => {
  const dispatch = useDispatch();
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const { eligibilityData } = useSelector((state) => state.claim);

  const { singleEliginilityData } = useSelector(
    (state) => state.eligibilityCheckList
  );

  const eligbilitPreauth = viewPreauthorizationInfo?.payer_response?.eligbid;
  const eligbilitClaim = viewClaimInfo?.payer_response?.eligbid;

  const { id, eligibility_id } = useParams();
  const location = useLocation();

  const eliId = id?.split("_");
  const eligibilityID = eliId?.pop();

  const queryId = id?.split("_");
  const queryEligibilityID = queryId?.pop();

  useEffect(() => {
    if (id && location.pathname.includes("/eligibility/eligibility-check")) {
      dispatch(GetSingleEligibilityData(eligibilityID || queryEligibilityID));
    } else if (
      location.pathname.includes("/preauthorization/preauthorization") &&
      eligbilitPreauth
    ) {
      dispatch(GetSingleEligibilityData(eligbilitPreauth));
    } else if (
      (location.pathname.includes("/claims/view-claim-response") || location.pathname.includes("/claims/claims-list")) &&
      eligbilitClaim
    ) {
      dispatch(GetSingleEligibilityData(eligbilitClaim));
    }
  }, [eligibilityID, location.pathname, eligbilitPreauth]);

  return (
    (eligibilityCheckData?.eligibility_id ||
      singleEliginilityData?.eligibility_id ||
      eligbilitPreauth ||
      eligbilitClaim ||
      eligibilityData?.id) && (
      <EliglibilityResponseContainer>
        <Tab.Pane eventKey="payer_response" className="mt-3">
          <EligibilityReposnePersonalDetails />
        </Tab.Pane>
        <Tab.Pane eventKey="benefit_tables" className="mt-3">
          <BenefitsTable />
        </Tab.Pane>
      </EliglibilityResponseContainer>
    )
  );
};

export default EliglibilityResposne;
